export const GENERIC_ERROR_MESSAGE = 'Action failed. Please try again.';
